/* Hero "Silver Glass" canvas - ported 1:1 from components/hero-background.tsx.
   Deterministic (seed 1337), offscreen sprites, 60fps cap, pauses off-screen /
   hidden tab / reduced-motion. Targets <canvas data-ni-hero> inside .ni-hero. */
(function () {
  'use strict';
  var canvas = document.querySelector('[data-ni-hero]');
  if (!canvas) return;
  var wrap = canvas.parentElement;
  var section = wrap;
  var ctx = canvas.getContext('2d', { alpha: true });
  if (!ctx) return;

  var GLOW = [200, 215, 208], TINT = [170, 190, 180], WHITE = [245, 250, 248];
  var GLOW_MUL = 0.55, ALPHA_MUL = 0.9, SHAPE_COUNT = 7, DUST_COUNT = 34, TRAIL_COUNT = 2;
  var rgba = function (c, a) { return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'; };

  var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  var seed = 1337;
  var rand = function () { seed = (seed * 1664525 + 1013904223) >>> 0; return seed / 4294967296; };
  var between = function (a, b) { return a + rand() * (b - a); };

  function blurred(sprite, px) {
    var c = document.createElement('canvas');
    c.width = sprite.width + px * 4; c.height = sprite.height + px * 4;
    var g = c.getContext('2d'); g.filter = 'blur(' + px + 'px)'; g.drawImage(sprite, px * 2, px * 2);
    return c;
  }
  function makeAt(size) {
    var pad = size * 0.5, c = document.createElement('canvas');
    c.width = c.height = Math.ceil(size + pad * 2);
    var g = c.getContext('2d'), cx = c.width / 2, cy = c.height / 2;
    g.font = "900 " + size + "px 'Helvetica Neue', Arial, sans-serif";
    g.textAlign = 'center'; g.textBaseline = 'middle';
    g.shadowColor = rgba(GLOW, 1); g.shadowBlur = size * 0.28 * GLOW_MUL;
    g.lineWidth = size * 0.045; g.strokeStyle = rgba(GLOW, 0.5 * GLOW_MUL);
    g.strokeText('@', cx, cy); g.strokeText('@', cx, cy); g.shadowBlur = 0;
    var body = g.createLinearGradient(cx - size / 2, cy - size / 2, cx + size / 2, cy + size / 2);
    body.addColorStop(0.0, rgba(WHITE, 0.34)); body.addColorStop(0.45, rgba(GLOW, 0.16)); body.addColorStop(1.0, rgba(TINT, 0.07));
    g.fillStyle = body; g.fillText('@', cx, cy);
    g.lineWidth = Math.max(1, size * 0.02); g.strokeStyle = 'rgba(255,255,255,0.85)';
    g.strokeText('@', cx - size * 0.018, cy - size * 0.022);
    g.lineWidth = Math.max(1, size * 0.014); g.strokeStyle = rgba(GLOW, 0.75);
    g.strokeText('@', cx + size * 0.014, cy + size * 0.02);
    g.beginPath(); g.arc(cx, cy, size * 0.34, Math.PI * 1.12, Math.PI * 1.42);
    g.lineWidth = size * 0.05; g.lineCap = 'round'; g.strokeStyle = 'rgba(255,255,255,0.38)'; g.stroke();
    return c;
  }
  function makeBlob(size) {
    var c = document.createElement('canvas'); c.width = c.height = size * 2;
    var g = c.getContext('2d'), cx = size, cy = size;
    g.beginPath(); var lobes = 3 + Math.floor(rand() * 3), roff = rand() * Math.PI * 2;
    for (var a = 0; a <= Math.PI * 2 + 0.01; a += 0.12) {
      var r = size * 0.55 * (1 + 0.22 * Math.sin(a * lobes + roff));
      var x = cx + Math.cos(a) * r, y = cy + Math.sin(a) * r * 0.82;
      if (a === 0) g.moveTo(x, y); else g.lineTo(x, y);
    }
    g.closePath();
    var fill = g.createRadialGradient(cx - size * 0.2, cy - size * 0.25, size * 0.1, cx, cy, size * 0.75);
    fill.addColorStop(0, rgba(WHITE, 0.5)); fill.addColorStop(0.55, rgba(GLOW, 0.22)); fill.addColorStop(1, rgba(GLOW, 0.03));
    g.shadowColor = rgba(GLOW, 1); g.shadowBlur = size * 0.3 * GLOW_MUL; g.fillStyle = fill; g.fill(); g.shadowBlur = 0;
    g.lineWidth = Math.max(1, size * 0.03); g.strokeStyle = rgba(WHITE, 0.5); g.stroke();
    return c;
  }
  function makeShard(size) {
    var c = document.createElement('canvas'); c.width = c.height = size * 2;
    var g = c.getContext('2d'), cx = size, cy = size;
    g.beginPath(); g.moveTo(cx, cy - size * 0.6); g.lineTo(cx + size * 0.55, cy + size * 0.42); g.lineTo(cx - size * 0.5, cy + size * 0.3); g.closePath();
    var fill = g.createLinearGradient(cx, cy - size * 0.6, cx, cy + size * 0.4);
    fill.addColorStop(0, rgba(WHITE, 0.4)); fill.addColorStop(1, rgba(GLOW, 0.08));
    g.shadowColor = rgba(GLOW, 1); g.shadowBlur = size * 0.35 * GLOW_MUL; g.fillStyle = fill; g.fill(); g.shadowBlur = 0;
    g.lineWidth = Math.max(1, size * 0.035); g.strokeStyle = rgba(WHITE, 0.65); g.stroke();
    return c;
  }
  function makeDot(size, bright) {
    var c = document.createElement('canvas'); c.width = c.height = size * 2;
    var g = c.getContext('2d'), grad = g.createRadialGradient(size, size, 0, size, size, size);
    grad.addColorStop(0, bright ? rgba(WHITE, 0.95) : rgba(GLOW, 0.8));
    grad.addColorStop(0.35, rgba(GLOW, 0.35)); grad.addColorStop(1, rgba(GLOW, 0));
    g.fillStyle = grad; g.fillRect(0, 0, c.width, c.height);
    return c;
  }
  var dots = [makeDot(14, false), makeDot(10, true), makeDot(20, false)];

  var ATS = [
    { x: 0.085, y: 0.6, s: 112, z: 1.0, blur: 0 }, { x: 0.9, y: 0.64, s: 98, z: 1.0, blur: 0 },
    { x: 0.93, y: 0.16, s: 84, z: 0.9, blur: 0 }, { x: 0.05, y: 0.28, s: 56, z: 0.7, blur: 2 },
    { x: 0.52, y: 0.1, s: 48, z: 0.6, blur: 3 }, { x: 0.24, y: 0.22, s: 40, z: 0.55, blur: 4 },
    { x: 0.68, y: 0.84, s: 48, z: 0.6, blur: 3 }, { x: 0.36, y: 0.88, s: 34, z: 0.5, blur: 5 },
    { x: 0.8, y: 0.36, s: 30, z: 0.5, blur: 5 },
  ].map(function (a) {
    return Object.assign({}, a, {
      sprite: a.blur ? blurred(makeAt(a.s), a.blur) : makeAt(a.s),
      ampX: between(8, 20), ampY: between(10, 22), sx: between(0.12, 0.3), sy: between(0.1, 0.26),
      rotAmp: between(0.06, 0.14), rotSpeed: between(0.08, 0.2), squashSpeed: between(0.1, 0.24),
      p: [rand() * 7, rand() * 7, rand() * 7, rand() * 7],
      alpha: (a.z >= 0.9 ? 0.95 : a.z * 0.8) * ALPHA_MUL,
    });
  });
  var SHAPES = [];
  for (var si = 0; si < SHAPE_COUNT; si++) {
    var x = rand(); var y = rand();
    if (Math.abs(x - 0.5) < 0.22) x = x < 0.5 ? x - 0.2 : x + 0.2;
    x = Math.min(0.97, Math.max(0.03, x));
    var size = between(20, 52), blur = size < 32 ? 3 : 0, make = rand() < 0.55 ? makeBlob : makeShard;
    SHAPES.push({ x: x, y: y, sprite: blur ? blurred(make(size), blur) : make(size),
      ampX: between(6, 18), ampY: between(9, 20), sx: between(0.1, 0.26), sy: between(0.08, 0.22),
      rotAmp: between(0.15, 0.5), rotSpeed: between(0.06, 0.16), p: [rand() * 7, rand() * 7, rand() * 7], alpha: between(0.35, 0.8) * ALPHA_MUL });
  }
  var DUST = [];
  for (var di = 0; di < DUST_COUNT; di++) DUST.push({ x: rand(), y: rand(), sprite: dots[Math.floor(rand() * dots.length)],
    amp: between(5, 16), sx: between(0.1, 0.4), sy: between(0.08, 0.3), drift: between(-0.004, 0.004),
    p: [rand() * 7, rand() * 7], alpha: between(0.15, 0.6) * ALPHA_MUL, scale: between(0.5, 1.3) });
  var TRAILS = [];
  for (var ti = 0; ti < TRAIL_COUNT; ti++) TRAILS.push({ x: between(0.15, 0.85), y: between(0.15, 0.8),
    len: between(0.08, 0.16), angle: between(-0.9, 0.9), curve: between(-1.2, 1.2), speed: between(0.05, 0.1), p: rand() * 7, alpha: between(0.25, 0.5) * ALPHA_MUL });

  var W = 0, H = 0, dpr = 1, rafId = 0, running = false, inView = false, last = 0;
  var FRAME_MIN = 1000 / 61;

  function resize() {
    dpr = Math.min(2, window.devicePixelRatio || 1);
    W = wrap.clientWidth; H = wrap.clientHeight;
    canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (!running) draw(performance.now());
  }
  function drawSprite(sprite, x, y, rot, scX, scY, alpha) {
    ctx.globalAlpha = alpha; ctx.translate(x, y); if (rot) ctx.rotate(rot); ctx.scale(scX, scY);
    ctx.drawImage(sprite, -sprite.width / 2, -sprite.height / 2); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function draw(now) {
    var t = now * 0.001, still = reduceMotion.matches;
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < DUST.length; i++) { var d = DUST[i];
      var drift = still ? 0 : (t * d.drift) % 1; var xx = (d.x + drift + 1) % 1;
      var ox = still ? 0 : Math.sin(t * d.sx + d.p[0]) * d.amp; var oy = still ? 0 : Math.sin(t * d.sy + d.p[1]) * d.amp;
      drawSprite(d.sprite, xx * W + ox, d.y * H + oy, 0, d.scale, d.scale, d.alpha);
    }
    ctx.globalCompositeOperation = 'lighter';
    for (var j = 0; j < TRAILS.length; j++) { var tr = TRAILS[j];
      var head = still ? 0.6 : (t * tr.speed + tr.p) % 1.3; var cos = Math.cos(tr.angle), sin = Math.sin(tr.angle);
      for (var k = 0; k < 14; k++) { var u = k / 13; var behind = head - u * 0.5;
        if (behind < 0 || behind > 1) continue;
        var along = behind * tr.len, bend = Math.sin(behind * Math.PI) * tr.curve * tr.len * 0.3;
        var xp = (tr.x + along * cos - bend * sin) * W, yp = (tr.y + along * sin + bend * cos) * H;
        var fade = (1 - u) * Math.sin(Math.min(1, behind) * Math.PI);
        ctx.globalAlpha = tr.alpha * fade; var s = dots[k % 2], sc = 0.4 + (1 - u) * 0.5;
        ctx.drawImage(s, xp - (s.width * sc) / 2, yp - (s.height * sc) / 2, s.width * sc, s.height * sc);
      }
    }
    ctx.globalCompositeOperation = 'source-over';
    for (var m = 0; m < SHAPES.length; m++) { var sh = SHAPES[m];
      var ox2 = still ? 0 : Math.sin(t * sh.sx + sh.p[0]) * sh.ampX; var oy2 = still ? 0 : Math.sin(t * sh.sy + sh.p[1]) * sh.ampY;
      var rot = still ? sh.p[2] * 0.1 : Math.sin(t * sh.rotSpeed + sh.p[2]) * sh.rotAmp;
      drawSprite(sh.sprite, sh.x * W + ox2, sh.y * H + oy2, rot, 1, 1, sh.alpha);
    }
    for (var n = 0; n < ATS.length; n++) { var a = ATS[n];
      var ox3 = still ? 0 : Math.sin(t * a.sx + a.p[0]) * a.ampX; var oy3 = still ? 0 : Math.sin(t * a.sy + a.p[1]) * a.ampY;
      var r = still ? 0 : Math.sin(t * a.rotSpeed + a.p[2]) * a.rotAmp;
      var scX = still ? 1 : 0.82 + 0.18 * Math.sin(t * a.squashSpeed + a.p[3]);
      var scY = still ? 1 : 0.94 + 0.06 * Math.sin(t * a.squashSpeed * 0.7 + a.p[1]);
      drawSprite(a.sprite, a.x * W + ox3, a.y * H + oy3, r, scX, scY, a.alpha);
    }
    ctx.globalAlpha = 1;
  }
  function loop(now) { rafId = requestAnimationFrame(loop); if (now - last < FRAME_MIN) return; last = now; draw(now); }
  function start() { if (running || reduceMotion.matches || !inView || document.hidden) return; running = true; last = 0; rafId = requestAnimationFrame(loop); }
  function stop() { running = false; cancelAnimationFrame(rafId); }

  new IntersectionObserver(function (e) { inView = e[0].isIntersecting; if (inView) start(); else stop(); }, { threshold: 0.02 }).observe(section);
  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', function () { if (reduceMotion.matches) { stop(); draw(performance.now()); } else start(); });
  new ResizeObserver(resize).observe(wrap);
  resize();
  if (reduceMotion.matches) draw(performance.now());
})();
